export function initCommentsFrameModule() {
   // Load this for the first comment-container on the block.
   const container = $E('.js-page-comments');
   if (container) {
      const commentContainer = container.closest('.js-comment-container');
      const manager = new CommentManager(container);
      commentContainer.store('commentManager', manager);
   }
}

export { CommentManager };
window.CommentManager = CommentManager;
function CommentManager(container) {
   const self = this;
   var comments = getElement('.js-comments');
   var form = getElement('.js-add-comment-form');
   // Store the comment manager for the form as well, because it's easier to find
   // the form from the comment box
   form.store('commentManager', this);
   var formTitle = form.getElement('.js-add-comment-title');
   var replyCommentText = form.getElement('.js-reply-comment-text');
   var replyCancel = form.getElement('.js-cancel-reply');
   var chars = null;
   var maxCharacters = null;
   var minCharacters = null;
   var commentCount = getElement('.js-comment-count');
   var runValidator = false;

   // These set when the form is opened and are sent along with the POST
   // that creates the comment.
   var context;
   var contextid;
   var parentid;

   if (form) {
      var formManager = new FormManager(form);

      addFormEvents(form);
   }

   addCommentActionHandlers(comments);

   function getEditor(el) {
      const editorId = el.getAttribute('data-editorid');
      const editorEl = document.getElementById(editorId);
      return window.prosemirrorComments.getOrCreateEditor(editorEl);
   }

   function refreshComments(loadedCallback) {
      const request = new Request.AjaxIO(getApiEndpoint())
         .send(context, contextid, false)
         .then(function(response) {
            comments.set('html', response.html);
            ModeratorVote.setupLinkActions();

            if (loadedCallback) {
               loadedCallback(comments);
            }
         });

      LoadingIndicator.withPromise(request, {
         hideSuccessMessage: true,
         pendingMessage: 'Loading comments...',
      });
      return request;
   }

   this.loadComments = function() {
      if (comments.get('data-loaded')) {
         return Promise.resolve();
      }
      context = container.get('data-context');
      contextid = container.get('data-contextid');
      return refreshComments().then(function() {
         comments.set('data-loaded', 1);
      });
   };

   function toggleDeletedCommentsHandler(event) {
      event.stop();
      var el = this;
      var text = _js('View Active');
      var newMode = 'deleted';
      var viewDeleted = true;

      if (el.get('data-mode') != 'active') {
         text = _js('View Deleted');
         newMode = 'active';
         viewDeleted = false;
      }

      new Request.AjaxIO(getApiEndpoint(), {
         onSuccess: function(response) {
            comments.set('html', response.html);
            ModeratorVote.setupLinkActions();
         },
      }).send(form.get('data-context'), form.get('data-contextid'), viewDeleted);

      el.set('html', text);
      el.set('data-mode', newMode);
   }

   function submit() {
      runValidator = true;
      var formManager = form.retrieve('FormManager:formManager');
      formManager.submit();
   }

   this.submit = submit;

   function addFormEvents(form) {
      chars = form.getElement('.maxCharacters');
      maxCharacters = parseInt(chars.get('text'), 10);
      minCharacters = parseInt(chars.getProperty('data-minimum'), 10);

      // This is a workaround for Safari <10.1
      // If the link editor popup is in the DOM when the add comment form gets
      // a submit event, ignore the submit event.
      formManager.addSubmitHandler(function() {
         var linkEditor = form.querySelector('.ProseMirror-widget input.js-link-editor');

         return linkEditor !== document.activeElement;
      });

      formManager.addSubmitHandler(function() {
         if (!runValidator) {
            return;
         }

         const editor = getEditor(form);

         var text = editor.text
            .trim()
            .replace(/\r\n?/, '\n')
            .replace(/ +/, ' ');
         var error = false;

         if (text.length <= 0) {
            error = _js('You cannot submit an empty comment!');
         } else if (text.length > maxCharacters) {
            /* Translators: %1 -> max characters; %2 -> character length; */
            error = _js(
               'Your comment is too long. Please keep it under %1 characters. It is currently %2 characters.',
               maxCharacters,
               text.length
            );
         } else if (text.length < minCharacters) {
            /* Translators: %1 -> min characters; %2 -> character length; */
            error = _js(
               'Your comment is too short. Please write something over %1 characters. It is currently %2 characters.',
               minCharacters,
               text.length
            );
         }

         runValidator = false;
         if (error) {
            formManager.showError(editor.el, error);
            return false;
         }
         return true;
      });

      formManager.addSubmitHandler(onSubmit);

      window.addEvents({
         'click:relay(.js-add-comment)': (ev, el) => {
            setupCommentEditor(el);
         },
         'click:relay(.js-scroll-to-editor)': (ev, el) => {
            ev.event.stopImmediatePropagation();
            const editorId = el.getAttribute('data-editorid');
            const editorEl = document.getElementById(editorId);
            const form = editorEl.getParent('form');

            new Fx.SmoothScroll(
               {
                  duration: 200,
               },
               window
            )
               .toElement(form, 'y')
               .chain(function() {
                  editorEl.focus();
               });
         },
      });

      container.addEvents({
         'click:relay(.js-comment-submit)': function() {
            runValidator = true;
         },

         'click:relay(.js-show-page-comments)': function(event) {
            self.loadComments();
            // The button gets removed when the comments are loaded,
            // but lets disable it to prevent double clicking anyway.
            event.target.setAttribute('disabled', '1');
         },
      });

      if (container.id) {
         // Watch for click events on buttons (anywhere in the document) which
         // indicate they should use this comment form.
         $$('.addComment[data-containerid=' + container.id + '])').addEvent('click', setupForm);
      }

      getElements('.js-toggle-deleted').addEvent('click', toggleDeletedCommentsHandler);
   }

   function updateCommentCount(difference) {
      if (!commentCount) {
         return;
      }
      var prevCount = parseInt(commentCount.get('data-numcomments'), 10);
      var count = prevCount + difference;

      var text;
      if (count === 1) {
         text = _js('One Comment');
      } else {
         text = _js('%1 Comments').replace('%1', count);
      }

      commentCount.set('data-numcomments', count);
      commentCount.set('text', text);
   }

   function replaceUrl() {
      // Note: 'this' is the element referenced in the selector for this event
      const url = this.getAttribute('href');
      history.replaceState(null, null, url);
      event.preventDefault();
   }

   function addCommentActionHandlers(commentsContainer) {
      commentsContainer.addEvents({
         'click:relay(.js-permalink)': replaceUrl,
         'click:relay(.js-edit-comment)': editCommentHandler,
         'click:relay(.js-delete-comment)': deleteCommentHandler,
         'click:relay(.js-restore-comment)': restoreCommentHandler,
      });
   }

   function setupFormData(el) {
      const title = el.get('title') || _js('Add Comment');
      parentid = el.get('data-parentid');

      const comment = document.querySelector(`.commentContent[data-commentid="${parentid}"]`);
      const isReply = !!comment;
      replyCommentText.empty();

      if (comment) {
         replyCommentText.append(comment.clone());
      }

      if (formTitle) {
         formTitle.set('text', title);
      }

      // Either clicked a seperate context (reply)
      // or we want the default one (normal comment)
      const overrideContext = el.get('data-context');
      const overrideContextid = el.get('data-contextid');

      context = isReply ? overrideContext : form.get('data-context');
      contextid = isReply ? overrideContextid : form.get('data-contextid');

      replyCancel.toggleClass('hidden', !isReply);

      form.removeClass('hidden');
      const editor = getEditor(el);
      const editorEl = editor.el;

      formManager.clear(editorEl);
   }

   function editCommentHandler(event) {
      const editor = getEditor(this);

      var el = this;
      event.stop();
      Auth.required({
         message: _js('Log in to edit a comment'),
         onAuthorize: function() {
            var comment = el.getParent('.comment');
            var content = comment.getFirst('.commentContent');
            var editDiv = comment.getFirst('.commentEditDiv');
            var commentid = el.get('data-commentid');

            var actions = getElements('.commentActions');
            actions.addClass('hidden');

            content.hide();
            editDiv.show();
            var req = new Request.API_2_0('comments/' + commentid, {
               method: 'PATCH',
               onSuccess: function(response) {
                  editDiv.hide();
                  content.set('html', response.text_rendered);
                  content.show();
                  editor.saveState();
                  actions.removeClass('hidden');
               },

               onFailure: function(xhr, message) {
                  StatusPanel.deactivate();
                  formManager.error(editor.el, message);
                  editor.el.addEvent('blur', function(ev) {
                     formManager.clearIfError(ev.target);
                  });
                  formManager.showStatusMessage(editor.el);
                  editor.focus();
               },
            });

            editDiv.getFirst('.js-cancel-edit').addEvent('click', function(ev) {
               content.show();
               editDiv.hide();

               formManager.clearIfError(editor.el);
               editor.reset();
               actions.removeClass('hidden');
            });

            var submitHandler = editDiv.getFirst('.js-submit-edit');
            if (!submitHandler.hasClass('submit-handler')) {
               submitHandler.addClass('submit-handler').addEvent('click', function(eve) {
                  eve.stop();
                  var newText = editor.value.trim();
                  req.send({ text: newText });
               });
            }
         },
      });
   }

   function destroyCommentElement(el) {
      var commentid = el.get('data-commentid');
      var comment = getElement('#comment-' + commentid);
      var replyParent = comment.getParent('.comment-reply');
      var commentParent = replyParent ? replyParent : comment.getParent('.comment-thread');

      var commentsDestroyed = 1;

      commentParent.destroy();
      if (replyParent === null) {
         var replies = comment.getSiblings('.comment-reply');
         commentsDestroyed += replies.length;
      }

      // Return the number of comment elements destroyed, to be used
      // in the total comment count.
      return commentsDestroyed;
   }

   function deleteCommentHandler(event) {
      var el = this;
      event.stop();
      Auth.required({
         message: _js('Log in to delete a comment'),
         onAuthorize: function() {
            var commentid = el.get('data-commentid');
            var comment = getElement('#comment-' + commentid);
            if (comment) {
               var confirmResult = confirm(_js('Are you sure you want to delete this comment?'));

               if (confirmResult) {
                  new Request.API_2_0('comments/' + commentid, {
                     method: 'DELETE',
                     onSuccess: function() {
                        var diff = destroyCommentElement(el);
                        updateCommentCount(-diff);
                     },
                  }).send();
               }
            }
         },
      });
   }

   function restoreCommentHandler(event) {
      var el = this;
      event.stop();
      Auth.required({
         message: _js('Log in to restore a comment'),
         onAuthorize: function() {
            new Request.AjaxIO('restoreComment', {
               onSuccess: function() {
                  var diff = destroyCommentElement(el);
                  updateCommentCount(diff);
               },
            }).send(el.get('data-commentid'));
         },
      });
   }

   function showApiError(xhr, message, editor) {
      StatusPanel.deactivate();
      formManager.showError(editor.el, message);
   }

   function onSubmit(el, ev) {
      contextid = contextid || form.get('data-contextid');
      context = context || form.get('data-context');
      const editor = getEditor(el);

      Auth.required({
         message: _js('Log in to add a new comment'),
         onAuthorize: function() {
            StatusPanel.loading(_js('Adding note...'), 20);
            new Request.API_2_0('comments/' + context + '/' + contextid, {
               method: 'POST',
               onSuccess: function(response) {
                  StatusPanel.deactivate();
                  chars.hide();
                  chars.set('text', maxCharacters);
                  editor.clear();
                  setupFormData(form);
                  formTitle.set('text', _js('Add Comment'));
                  replyCancel.addClass('hidden');
                  refreshComments(function(comments) {
                     updateCommentCount(/* difference = */ 1);

                     // Invalidate editorMapping entries for comments whose
                     // HTML is about to be replaced by refreshComments.
                     var childComments = comments.getElementsByClassName('comment');
                     Array.prototype.slice.call(childComments).forEach(function(comment) {
                        delete window.editorMapping[comment.id];
                     });

                     // Re-initialize autocompleter, now that there's a new
                     // input for adding comments.
                     if (App.setMentions) {
                        // This doesn't work on ProseMirror anyway.
                        //new Mentions();
                     }
                  });
               },
               onFailure: (xhr, message) => {
                  showApiError(xhr, message, editor);
               },
               onComplete: function() {
                  StatusPanel.deactivate();
               },
            }).send({
               text: editor.value,
               parentid: parentid,
               langid: App.langid,
            });
         },
      });
   }

   function getElement(selector) {
      return container.getElement(selector);
   }

   function getElements(selector) {
      return container.getElements(selector);
   }

   /**
    * Event handler to be used when registering click events on
    * buttons that should show the comment form.
    */
   function setupForm(el) {
      const editor = getEditor(el);

      Utils.UnsavedChanges.addHandler(function() {
         if (editor.value.trim() !== '') {
            return _js(
               'Your comments have not yet been posted. Your changes will be lost if you continue.'
            );
         }
      });

      setupFormData(el);
   }

   function getCommentManager(el) {
      const commentContainer = el.closest('.js-comment-container');
      let manager =
         commentContainer.retrieve('commentManager') || createCommentManager(commentContainer);
      commentContainer.store('commentManager', manager);
      return manager;
   }

   function createCommentManager(commentContainer) {
      var manager = new CommentManager(commentContainer);
      commentContainer.store('commentManager', manager);
      return manager;
   }

   function setupCommentEditor(el) {
      const manager = getCommentManager(el);
      manager.setupCommentEditor(el);
   }

   this.setupCommentEditor = el => {
      setupForm(el);
   };

   function getApiEndpoint() {
      return container.get('data-api') || 'getGroupedCommentsHtml';
   }
}
